// extracted by mini-css-extract-plugin
export var activeFilterButton = "_j7-c";
export var backButton = "_j7-4";
export var backIcon = "_j7-5";
export var chevronShortcut = "_j7-6";
export var container = "_j7-1";
export var editor = "_j7-8";
export var editorWrapper = "_j7-7";
export var prefix = "_j7-2";
export var searchIcon = "_j7-3";
export var suffix = "_j7-9";
export var suffixContent = "_j7-a";
export var suffixText = "_j7-b";
export var wrapper = "_j7-0";